<template>
	<div class="d-flex flex-column align-center width-full">
		<div
			class="d-flex flex-column align-center width-full height-full max-content-width"
			:class="isMobile ? ' px-5' : 'px-6'"
		>
			<div
				class="d-flex flex-column height-full z-1"
				:class="isMobile ? 'width-full ' : 'width-10'"
			>
				<slot />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	interface Props {
		isMobile: boolean
	}

	defineProps<Props>()
</script>

<style scoped>
	.width-10 {
		width: 100%;
		max-width: 93.3333333333%;
	}

	.max-content-width {
		max-width: 1440px;
	}

	@media (max-width: 1440px) {
		.max-content-width {
			max-width: 1280px;
		}
	}
</style>
